import styled, { css } from "styled-components";
import { ReactSVG } from "react-svg";

export const Container = styled.div`
  max-width: 90%;
  margin: 0 auto;
`;

export const Card = styled.div`
  background: #fff;
  li {
    list-style: none;
  }
  .last {
    border: none;
  }
`;
export const SearchWrapper = styled.div`
  .boxSearch Button {
    width: 100%;
    height: 30px;
    font-size: 14px !important;

    padding: 4px 17px;
    border-radius: 6px;

    @media only screen and (max-width: 500px) {
      width: 170px;
      height: 30px;
      font-size: 12px !important;
    }
  }

  @media only screen and (max-width: 855px) {
    .boxSearch {
      display: flex;
      justify-content: flex-start;
      align-items: start;
    }
  }
`;

export const BoxSearch = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: start;
  margin: 25px auto;
  border-radius: 7px;
  padding: 2.5rem;
  border: 1px solid gray;
  border-radius: 7px;

  @media (max-width: 1500px) {
    display: flex;
    padding: 2rem;
  }

  #firstColumnWrapper {
    display: flex;
    flex-direction: column;
    width: 70%;
    padding-left: 2.5%;
    margin-top: -10px;

    #innerWrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      width: 100%;

      #firstInner {
        width: 50%;
      }

      #secondInner {
        width: 50%;
        padding: 0 0 0 2.5%;
      }
    }
  }

  #secondColumnWrapper {
    display: flex;
    flex-direction: column;
    width: 35%;
    height: 100%;
    margin-top: -1rem;
  }

  #inputContainer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    @media (max-width: 1500px) {
      display: inline-block;
      margin-right: 5rem;
      width: 70%;
    }
  }

  #inputWrapper {
    margin-right: 7rem;
    width: 40%;
    z-index: 5;

    @media (max-width: 1600px) {
      margin-right: 5rem;
    }
    @media (max-width: 1200px) {
      margin-right: 2rem;
    }
  }

  .comboboxSituacao {
    margin-top: -5px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: right;
  justify-content: right;
  button {
    margin: 2.2rem 0 0 1rem;
  }
`;

export const CardHeader = styled.div`
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 2px #bbbbbb;

  ${({ theme }) => css`
    .border {
      padding: 10px;
      color: ${theme.colors.gray};
      font-size: 1.3rem;
      width: 37%;
      height: auto;
      text-align: center;
    }
  `}

  @media only screen and (max-width: 500px) {
    .border {
      padding: 0;
      text-align: center;
      width: 44%;
    }

    span {
      font-size: 1.2rem;
    }
  }

  @media (min-width: 1600px) {
    .border {
      width: 35%;
    }
  }
`;

export const CardBody = styled.div`
  width: 100%;
  padding: 0;
`;

export const SvgIcon = styled(ReactSVG)`
  margin-right: 2rem;
  position: relative;
  top: 0.7rem;
  left: 1rem;
  fill: #00a2e0 !important;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export const SvgIconInvert = styled(ReactSVG)`
  width: 2.5rem;
  fill: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SvgIconDisabled = styled(ReactSVG)`
  margin-right: 2rem;
  width: 3rem;
  height: 35.2px;
  margin: 4px 25.4px 4.6px 0;
  fill: #cccccc !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatusSpacer = styled.span`
  color: #000;
  opacity: 0.2;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const SelectContainer = styled.div``;

export const RodaPe = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const SelectPaginacaoWrapper = styled.div`
  width: 70%;
`;
